/**
 * Handles sidebar navigation functionality including smooth scrolling
 * and active section highlighting
 */
export function initHomeSecondaryNavigation() {
  const sidebarLinks = document.querySelectorAll('.secondary-menu a');

  // Get unique sections using a Set to remove duplicates
  const uniqueSectionIds = new Set();
  const sections = [];

  // First collect all unique section IDs
  Array.from(sidebarLinks).forEach(link => {
    const targetId = link.getAttribute('href').substring(1);
    uniqueSectionIds.add(targetId);
  });

  // Then create the sections array with unique elements only
  uniqueSectionIds.forEach(id => {
    const section = document.getElementById(id);
    if (section) sections.push(section);
  });

  // Skip if elements don't exist (e.g., on other pages)
  if (sidebarLinks.length === 0 || sections.length === 0) {
    return;
  }

  // Smooth scroll to section when clicking sidebar links
  sidebarLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // Smooth scroll to the target element with increased offset (150px instead of 100px)
        window.scrollTo({
          top: targetElement.offsetTop - 150, // Increased offset to position 50px higher
          behavior: 'smooth'
        });
      }
    });
  });

  // Highlight active section on scroll
  function highlightActiveSection() {
    const scrollPosition = window.scrollY + 200; // Add offset to trigger earlier
    const sidebarLinks = document.querySelectorAll('#sidebar-navigation .secondary-menu a');

    // Check if we're above the first section
    if (sections[0] && scrollPosition < sections[0].offsetTop) {
      // If we're above the first section, remove active class from all links
      sidebarLinks.forEach(link => link.classList.remove('active'));
      return;
    }

    sections.forEach((section, index) => {
      if (!section) return;

      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;

      // Check if the current scroll position is within this section
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        // Add active class to the corresponding sidebar link
        sidebarLinks.forEach(link => link.classList.remove('active'));
        sidebarLinks[index].classList.add('active');
      }
    });
  }

  // Initial check for active section
  highlightActiveSection();

  // Throttle function
  function throttle(callback, delay = 100) {
    let timeout = null;
    return function(...args) {
      if (!timeout) {
        timeout = setTimeout(() => {
          callback.apply(this, args);
          timeout = null;
        }, delay);
      }
    };
  }

  // Apply throttling to the scroll event (runs at most once every 100ms)
  window.addEventListener('scroll', throttle(highlightActiveSection, 100));
}

export default initHomeSecondaryNavigation;